module.exports = __webpack_public_path__ + "static/media/img_main_plant_01.b3f42824.png";